import cs from './cs.json.mjs';
import de from './de.json.mjs';
import en from './en.json.mjs';
import es from './es.json.mjs';
import fr from './fr.json.mjs';
import hu from './hu.json.mjs';
import id from './id.json.mjs';
import it from './it.json.mjs';
import ja from './ja.json.mjs';
import pl from './pl.json.mjs';
import pt from './pt.json.mjs';
import ro from './ro.json.mjs';
import ru from './ru.json.mjs';
import th from './th.json.mjs';
import tr from './tr.json.mjs';
import uk from './uk.json.mjs';
import zhCN from './zh-CN.json.mjs';
import zhHK from './zh-HK.json.mjs';

const translations = {
  cs,
  de,
  en,
  'en-US': en,
  es,
  fr,
  hu,
  id,
  it,
  ja,
  pl,
  pt,
  ro,
  ru,
  th,
  tr,
  uk,
  'zh-CN': zhCN,
  'zh-HK': zhHK
};

export { translations as default };
//# sourceMappingURL=index.mjs.map
